export default "__VITE_ASSET__MTNaEp2b__"